<script>
    import { setContext } from "svelte";
    import { writable } from "svelte/store";
    export let accordion = true;
    const clsPrefix = "sui-acc";
    const items = writable({});
    setContext("Accordion", {
        items,
        add: (item) => {
            items.update((old) => ({ ...old, [item.id]: item.active }));
        },
        toggle: (item) => {
            items.update((old) => {
                if (accordion) {
                    Object.keys(old).forEach((id) => (old[id] = false));
                }
                return { ...old, [item.id]: item.active };
            });
        },
    });
</script>

<ul class={clsPrefix}>
    <slot />
</ul>

<style lang="less">
    @import "./accordion.less";
</style>
